/**
 * Standalone scroll-reveal initializer — imported LAZILY via dynamic import.
 * NOT imported during initial render, so it doesn't add to critical JS parse time.
 *
 * Uses a single shared IntersectionObserver.
 * Elements with class "reveal" or "reveal-left" get ".is-visible" when visible.
 * Re-scans periodically to catch dynamically loaded content.
 */

let observer: IntersectionObserver | null = null

function getObserver(): IntersectionObserver {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        for (let i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-visible')
            observer!.unobserve(entries[i].target)
          }
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' },
    )
  }
  return observer
}

function observeElements() {
  const els = document.querySelectorAll(
    '.reveal:not(.is-visible), .reveal-left:not(.is-visible)',
  )
  const obs = getObserver()
  for (let i = 0; i < els.length; i++) {
    obs.observe(els[i])
  }
}

export function initScrollReveal() {
  // Initial scan
  observeElements()

  // Use MutationObserver to catch lazy-loaded content
  const mo = new MutationObserver(() => {
    observeElements()
  })

  mo.observe(document.body, {
    childList: true,
    subtree: true,
  })

  // Safety: stop watching after 30s (all content should be loaded by then)
  setTimeout(() => {
    mo.disconnect()
    // One final scan
    observeElements()
  }, 30000)
}
